type WithId = { id?: string | number }

export const mapDirtyFormInputs = <T extends WithId>(oldData: T, newData: T): Partial<T> => {
  const oldDataMap = new Map(Object.entries(oldData))
  const newDataMap = new Map(Object.entries(newData))
  let changedInputs: Partial<T> = {}

  newDataMap.forEach((value, key) => {
    if (oldDataMap.get(key) !== value) {
      changedInputs[key as keyof T] = value as T[keyof T]
    }
  })

  // Ensure id is included in the changedInputs if it exists
  if (oldData.id !== undefined) {
    changedInputs.id = oldData.id
  }

  return changedInputs
}
